// utils/manager.js

export const getClient = (manager, clientId) => {
  return manager.clients.find(client => client.id === clientId)
}
